module.exports = __webpack_public_path__ + "europa-5-microprint.jpg?6dd83bf18ae39f4e7b129f4120502503";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5-microprint.jpg
// module id = 349
// module chunks = 0